module.exports = __webpack_public_path__ + "static/media/400087_02.1258553b.png";